import PropTypes from "prop-types";
import { MEDIA_PERMISSIONS } from "../../constants/CallSettingConstants";
import ActiveSpeaker from "../Twilio/DominantSpeakerAnalyzer/ActiveSpeaker";
const RemoteParticipantsMicrophoneState = ({ isUserAudioEnabled, audioPermission, localisedValues, userIdentity }) => {
    return (
        <div className='participant-action-info custom-tooltip tooltip-auto-width m-hide'>
            <div className='participant-action-icon'>
                {isUserAudioEnabled && (
                    <>
                        <span className='for-icon icon-mic-on-stroke light-icon' data-testid='icon-audio-active'></span>{" "}
                        <ActiveSpeaker userIdentity={userIdentity} isUserAudioEnabled={isUserAudioEnabled} fromWhere='overlay' />
                    </>
                )}
                {!isUserAudioEnabled && audioPermission !== MEDIA_PERMISSIONS.BLOCKED_VALUE && (
                    <span className='for-icon light-icon icon-mute-stroke' data-testid='icon-audio-mute'></span>
                )}
                {!isUserAudioEnabled && audioPermission === MEDIA_PERMISSIONS.BLOCKED_VALUE && (
                    <span className='for-blocked-icon' data-testid='icon-audio-blocked'>
                        <span className='for-icon light-icon icon-unmute'></span>
                        <span className='for-close-icon'>
                            <span className='for-close-icon-in icon-close-light'></span>
                        </span>
                    </span>
                )}
            </div>
            <div className='custom-tooltip-content text-nowrap'>
                <div className='custom-tooltip-in'>
                    {isUserAudioEnabled && <p>{localisedValues?.microphone_unmuted}</p>}
                    {!isUserAudioEnabled && audioPermission !== MEDIA_PERMISSIONS.BLOCKED_VALUE && <p>{localisedValues?.microphone_muted}</p>}
                    {!isUserAudioEnabled && audioPermission === MEDIA_PERMISSIONS.BLOCKED_VALUE && <p>{localisedValues?.microphone_blocked}</p>}
                </div>
            </div>
        </div>
    );
};

RemoteParticipantsMicrophoneState.propTypes = {
    isUserAudioEnabled: PropTypes.any,
    audioPermission: PropTypes.any,
    localisedValues: PropTypes.any,
};
export default RemoteParticipantsMicrophoneState;
